import React, { useEffect, useState } from "react";
import "../_css/Notification.css";
import { getNotifications, markNotificationAsRead, markNotificationsAsRead } from "../requests";
import { useDispatch } from "react-redux";
import { stop_notications } from "../_store/reducers/notificationReducer";
import { deleteAuthToken, notifyError } from "../utils/helper";
import { useNavigate } from "react-router-dom";
import { startLoader, stopLoader } from "../_store/reducers/loaderReducer";

const Notification = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState([]);

  const fetchAllNotifications = async () => {
    dispatch(startLoader())
    try {
      const res = await getNotifications();
      if (res.status < 400) {
        setNotifications(res.data.notifications);
      }
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate('/login')
        return;
      }

      notifyError(error?.response?.data?.error || "Something went wrong");
    }finally{
      dispatch(stopLoader())
    }
  };

  const markAllAsRead = async () => {
    try {
      const res = await markNotificationAsRead({});
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };

  useEffect(() => {
    fetchAllNotifications();
    markAllAsRead();
  }, []);

 
  //   socket.on("newNotification", (data) => {
  //     setNotifications((prev) => [data, ...prev]);
  //   });

  //   // console.log(notifications);

  //   // // Cleanup
  //   return () => {
  //     socket.off("newNotification");
  //   };
  // }, [notifications]);

  return (
    <div className="notification-main">
      <div className={notifications.length ? "popup" : "zero-popup"}>
        <div className="notification-head">
          <div className="notification-head-text">Notification</div>
          <img
            style={{ cursor: "pointer" }}
            onClick={() => dispatch(stop_notications())}
            src="/close.svg"
            width="18px"
            height="18px"
          />
        </div>

        <div className="notification-body">
          {notifications.length > 0 &&
            notifications.map((e,i) => (
              <div key={i} className="notification-list">
                <div className="di-flex">
                {/* <div className="notification-img"></div> */}
                <div className="notification-content">
                  <div className="notification-content-title">{e.title}</div>
                  <div className="notification-content-desc">{e.message}</div>
                </div>
                </div>
                <div className="notification-time">
                  {new Date(e.created_at)
                    .toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .toUpperCase()}
                </div>
              </div>
            ))}

          {notifications.length == 0 && (
            <div className="notify-zero-body">
              <div className="notification-img"></div>
              <div className="notification-content-zero">
                <div className="notification-content-title">
                  No Notification
                </div>
                <div className="notification-content-desc">
                  We will notify you
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      ;
    </div>
  );
};

export default Notification;
